import React from 'react';
import AppHeader from './Header';
import AppContent from './Content';
import AppFooter from './Footer';
import { LanguageProvider } from './LanguageContext';
import './App.css';

const App = () => {
  return (
    <LanguageProvider>
      <div className="app-frame">
        <AppHeader />
        <AppContent />
        <AppFooter />
      </div>
    </LanguageProvider>
  );
};

export default App;
